export const PERIOD = 'period';
export const CHOICE = 'choice';
export const DAYS = 'days';
